import React from 'react';
import { View, Text } from '@react-pdf/renderer';

/**
 * DRAFT watermark for the transmittal forms (Submittal, RFI, Letter of Transmittal).
 *
 * The same overlay DsPackagePdfDocument draws on package datasheets, duplicated rather than
 * imported: that one is private to the datasheet document, and the reports-pipeline original
 * belongs to the locked I/O Assignments export path. Tuned for LETTER portrait (612 x 792pt).
 *
 * The mark repeats in a diagonal zig-zag of five copies so every part of the form carries it -
 * a single central copy is easy to crop out. A trailing "Construction" drops to its own line so
 * a long mark such as "Draft - Not for Construction" is never clipped.
 *
 * Render it as the FIRST child inside <Page>: `fixed` repeats it on every page, and the form
 * then draws over it rather than under it. Nothing renders when `text` is empty, which is how
 * a published transmittal prints clean.
 */
const WM_BOX_W = 300;
const WM_BOX_H = 110;
// Centre points of each copy on the 612 x 792 page.
const WM_CENTRES = [[160, 100], [452, 248], [306, 396], [160, 544], [452, 692]];

const watermarkLines = text => String(text).replace(/\s+(construction)\s*$/i, '\n$1').split('\n');

const TransmittalWatermark = ({ text }) => (text ? (
  <View
    fixed
    style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden', opacity: 0.13 }}
  >
    {WM_CENTRES.map(([cx, cy]) => (
      <View
        key={`${cx}-${cy}`}
        style={{
          position: 'absolute', left: cx - WM_BOX_W / 2, top: cy - WM_BOX_H / 2,
          width: WM_BOX_W, height: WM_BOX_H, justifyContent: 'center', transform: 'rotate(-28deg)',
        }}
      >
        {watermarkLines(text).map((line, i) => (
          <Text
            key={i}
            style={{
              // A short mark (DRAFT) prints large; a long one steps down so it stays inside its box.
              fontSize: String(text).length > 12 ? 26 : 60,
              fontFamily: 'Helvetica-Bold',
              color: '#000000',
              textTransform: 'uppercase',
              letterSpacing: String(text).length > 12 ? 3 : 6,
              textAlign: 'center',
            }}
          >
            {line}
          </Text>
        ))}
      </View>
    ))}
  </View>
) : null);

export default TransmittalWatermark;
